import type { HubSpotIdentifyPayload } from '../types/hubspot.js';
import { logger } from '../utils/logger.js';

/**
 * Vérifie juste que le script HubSpot tracking est bien chargé par Webflow.
 * Ne charge plus rien — Webflow s'en charge via son custom code.
 */
export function loadHubSpotScript(): void {
  const existing = document.querySelector('script[src*="hs-scripts.com"]');
  if (existing) {
    logger.info('HubSpot script déjà chargé par Webflow');
  } else {
    logger.warn('HubSpot script non trouvé — vérifier le custom code Webflow');
  }
}

/**
 * Pousse un identify dans la queue _hsq.
 * Fonctionne même si le script n'est pas encore chargé (queue différée).
 */
export function hsqIdentify(payload: HubSpotIdentifyPayload): void {
  window._hsq = window._hsq ?? [];
  window._hsq.push(['identify', payload]);
  logger.info('_hsq identify poussé', payload);
  logger.table(payload);
}

/**
 * Pousse un trackPageView dans la queue _hsq.
 */
export function hsqTrackPageView(): void {
  window._hsq = window._hsq ?? [];
  window._hsq.push(['trackPageView']);
  logger.info('_hsq trackPageView poussé');
}
